import { Pipe, PipeTransform } from '@angular/core';
import { Observable, from, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ExerciseHistory } from 'src/models/exercise.model';
import { ExerciseService } from 'src/services/exercise-service.service';

@Pipe({
    name: 'getPr',
    standalone: false
})
export class GetPrPipe implements PipeTransform {
  constructor(private exerciseService: ExerciseService) {}

  transform(exerciseId: string): Observable<ExerciseHistory | null> {
    // Convert the Promise returned by getExerciseHistoryWithHighestWeightAndReps to an Observable
    return from(
      this.exerciseService.getExerciseHistoryWithHighestWeightAndReps(
        exerciseId
      )
    ).pipe(
      map((exerciseHistory) => exerciseHistory || null), // Convert undefined to null
      catchError((error) => {
        console.error('Error fetching exercise history:', error);
        return of(null); // Return an Observable that emits null in case of an error
      })
    );
  }
}
